/* eslint-disable react/no-unstable-nested-components */
import { RadioGroup, RadioGroupItem } from "components/ui/RadioGroup";
import classNames from "components/ui/classNames";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from "lucide-react";

interface TextAlignmentRadioGroupProps {
  value: "LEFT" | "CENTER" | "RIGHT";
  onChange: (value: "LEFT" | "CENTER" | "RIGHT") => void;
}
export default function TextAlignmentRadioGroup({ value, onChange }: TextAlignmentRadioGroupProps) {
  return (
    <RadioGroup
      loop={false}
      className={classNames(
        "grid w-full grid-cols-3 justify-between rounded-2xl border border-slate-200 bg-slate-50/60 p-1",
        "sm:flex sm:w-auto sm:max-w-xs sm:justify-normal sm:space-x-2",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
      )}
      orientation="horizontal"
      value={value}
      onValueChange={(value) => onChange(value as "LEFT" | "CENTER" | "RIGHT")}
    >
      {[
        {
          icon: <AlignLeftIcon />,
          align: "LEFT",
        },
        {
          icon: <AlignCenterIcon />,
          align: "CENTER",
        },
        {
          icon: <AlignRightIcon />,
          align: "RIGHT",
        },
      ].map(({ align, icon }) => {
        return (
          <RadioGroupItem
            key={align}
            value={align}
            disabled={false}
            title={align}
            className={classNames(
              "h-9 w-full items-center justify-center rounded-xl p-1 text-center sm:w-10",
              "border border-transparent text-sm font-medium tracking-wide",
              "text-slate-500 dark:text-slate-400",
              "data-[state=checked]:bg-violet-50 data-[state=checked]:font-bold data-[state=checked]:text-violet-600",
              "data-[state=checked]:dark:border-slate-800 data-[state=checked]:dark:bg-violet-600/30 data-[state=checked]:dark:text-violet-200",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-100 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-300",
              "data-[state=checked]:focus-visible:rounded-xl data-[state=checked]:focus-visible:bg-gray-50 data-[state=checked]:focus-visible:text-gray-600",
              "dark:focus-visible:ring-1 dark:focus-visible:ring-violet-950 dark:focus-visible:ring-offset-violet-950",
            )}
          >
            {icon}
          </RadioGroupItem>
        );
      })}
    </RadioGroup>
  );
}
